import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { AvailableLocale } from '@/i18n'

export type SettingsState = {
  isDeveloper: boolean
  locale: AvailableLocale | 'auto'
}

export const initialState: SettingsState = {
  isDeveloper: false,
  locale: 'auto',
}

const SettingsSlice = createSlice({
  extraReducers: builder => {},
  initialState,
  name: 'settings',
  reducers: {
    setIsDeveloper(state, action: PayloadAction<boolean>) {
      state.isDeveloper = action.payload
    },
    setLocale(state, action: PayloadAction<AvailableLocale | 'auto'>) {
      state.locale = action.payload
    },
  },
})

export const SettingsReducer = SettingsSlice.reducer

export const SettingsActions = SettingsSlice.actions
